import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SmartImgModule } from '@greco/ui-smart-img';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';

@NgModule({
  imports: [CommonModule, SmartImgModule],
  declarations: [UserAvatarComponent],
  exports: [UserAvatarComponent],
})
export class UserAvatarModule {}
